<template>
  <div>
    <label for="teachino-file-upload" @click.prevent>
      <slot
        :start-file-selection="
          () => {
            startFileSelection();
            return fileSelectedPromise;
          }
        "
      >
        <TButton
          :type="buttonType"
          :color="buttonColor"
          icon="upload"
          @click="startFileSelection"
          >{{ $t('library.file_upload.choose_files') }}</TButton
        >
      </slot>
    </label>
    <input
      id="teachino-file-upload"
      ref="fileInputRef"
      type="file"
      class="hidden"
      :multiple="multiple"
      :accept="acceptedMimetypes.join(',')"
      @change="selectFiles"
    />
  </div>
</template>
<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';
import { ref } from 'vue';
import TButton from '../Button/TButton.vue';
import type { ButtonColor, ButtonType } from '../Button/button-types';
import { useToast } from '../Toast/useToast';

const toast = useToast();
const fileInputRef = ref<HTMLInputElement>();

let resolveFileSelect: (files: File[]) => void;
let fileSelectedPromise = new Promise<File[]>(
  (resolve) => (resolveFileSelect = resolve),
);

withDefaults(
  defineProps<{
    multiple?: boolean;
    acceptedMimetypes?: string[];
    /** Style of the default "choose files" button (defaults to filled/primary). */
    buttonType?: ButtonType;
    buttonColor?: ButtonColor;
  }>(),
  {
    multiple: false,
    acceptedMimetypes: () => [],
    buttonType: 'filled',
    buttonColor: 'primary',
  },
);

const emit = defineEmits<{
  filesSelected: [File[]];
}>();

function startFileSelection() {
  console.log('startFileSelection');
  fileInputRef.value?.click();
}

function selectFiles(event: Event) {
  const target = event.target as HTMLInputElement;
  if (target.type !== 'file') {
    toast.error();
    return;
  }
  const fileList = target.files;
  if (!fileList) {
    return;
  }
  const files = Array.from(fileList);
  resolveFileSelect(files);
  fileSelectedPromise = new Promise<File[]>(
    (resolve) => (resolveFileSelect = resolve),
  );

  emit('filesSelected', files);

  // iirc this is a fix for a random chrome bug with uploads, although i dont remember exactly
  if (event.target) {
    (event as Event & { target: { value: string } }).target.value = '';
  }
}
</script>
